import React , { Component } from "react";

export default class Home extends Component {
    render() {
        return (
    
          <section class="portifolio" id="portifolio">
          <h2 class="heading">Latest <span>Project</span></h2>
          <div class="portifolio-container">
              <div class="portifolio-box">
                  <img src="images/superstore.png" alt="port" />
                  <div class="portifolio-layer">
                      <h4>Superstore</h4>
                      <p> Superstore Tanzania is your favorite online store for Groceries and Dubai products.</p>
                      <a href="https://superstore.co.tz/"><i class="bx bx-link-external"></i></a>
                  </div>
              </div>
              <div class="portifolio-box">
                  <img src="images/port5.jpg" alt="port" />
                  <div class="portifolio-layer">
                      <h4>E-kilimo Portal</h4>
                      <p>government authorities involved in agricultural issues to enable farmers to do better farming and
                          increase</p>
                      <a href="https://e-kilimo.co.tz/"><i class="bx bx-link-external"></i></a>
                  </div>
              </div>
              <div class="portifolio-box">
                  <img src="images/certified.png" alt="port" />
                  <div class="portifolio-layer">
                      <h4>Certified</h4>
                      <p>Certified Solutions is registered entity in Tanzania offering custom software development and digital product services.</p>
                      <a href="https://"><i class="bx bx-link-external"></i></a>
                  </div>
              </div>
              <div class="portifolio-box">
                  <img src="images/coke4.jpg" alt="port" />
                  <div class="portifolio-layer">
                      <h4>Cocacola Fleet</h4>
                      <p>System that helps to help making pre inspection of drives in Truck.</p>
                      <a href="https://"><i class="bx bx-link-external"></i></a>
                  </div>
              </div>
              <div class="portifolio-box">
                  <img src="images/port1.jpg" alt="port" />
                  <div class="portifolio-layer">
                      <h4>Dashboard</h4>
                      <p>Lorem ipsum dolor sit amet consectetur adipisicing. elite mairoles ratione.</p>
                      <a href="https://"><i class="bx bx-link-external"></i></a>
                  </div>
              </div>
              <div class="portifolio-box">
                  <img src="images/port6.jpg" alt="port" />
                  <div class="portifolio-layer">
                      <h4>Wordpress Design</h4>
                      <p>Lorem ipsum dolor sit amet consectetur adipisicing. elite mairoles ratione.</p>
                      <a href="https://"><i class="bx bx-link-external"></i></a>
                  </div>
              </div>
          </div>
      </section>
        )
      }
}